// Pure avatar helpers, moved verbatim from app components/QAvatar (initials.ts
// + the colour list / seed logic in QAvatar.vue) so the React QAvatar and the
// Vue one share one source. Move, not refactor.

const MAX_INITIALS = 2

export function getInitials(username: string) {
  const parts = username.split(/[ -]/)
  let initials = parts.map((part) => part[0]).join('')

  if (initials.length > MAX_INITIALS && initials.search(/[A-Z]/) !== -1) {
    initials = initials.replace(/[a-z]+/g, '')
  }

  initials = initials.slice(0, MAX_INITIALS).toUpperCase()

  return initials
}

export const avatarBackgroundColors = [
  'var(--brand-40)',
  'var(--brand-50)',
  'var(--blue-40)',
  'var(--blue-50)',
  'var(--pink-40)',
  'var(--pink-50)',
  'var(--orange-40)',
  'var(--orange-50)',
  'var(--yellow-40)',
  'var(--yellow-50)',
  'var(--green-40)',
  'var(--green-50)',
  'var(--teal-40)',
  'var(--teal-50)',
  'var(--purple-40)',
  'var(--purple-50)',
]

export function randomBackgroundColor(seed: number, colors: string[]) {
  return colors[seed % colors.length]
}
